import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

/**
 * Determines if current host is a tenant subdomain.
 */
export function isTenantHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const host = window.location.host;

  // Primary: meta tag injected by backend
  let main = '';
  if (typeof document !== 'undefined') {
    main =
      document
        .querySelector('meta[name="app-domain"]')
        ?.getAttribute('content') || '';
  }

  // Fallback: bootstrap base_url host if meta is missing or empty
  if (!main) {
    try {
      const {getBootstrapData} = require('@ui/bootstrap-data/bootstrap-data-store');
      const baseUrl = getBootstrapData()?.settings?.base_url;
      if (baseUrl) {
        main = new URL(baseUrl).host;
      }
    } catch (e) {
      main = '';
    }
  }

  // If we still don't have a main host, treat any dotted host as tenant
  if (!main) {
    return host.includes('.');
  }

  return Boolean(host && main && host !== main && host !== `www.${main}`);
}

/**
 * Determines if the current user is a tenant administrator.
 * 
 * A user is considered a tenant admin if:
 * 1. We are on a tenant host (subdomain)
 * 2. The user has admin.access permission
 * 3. The user has NO roles assigned (no role_id in user_role table)
 * 
 * If a user has roles, they are a regular tenant member, not an admin.
 */
export function isTenantAdmin(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const bootstrapData = getBootstrapData();
  

  
  // Must be on a tenant host
  if (!bootstrapData?.current_tenant) {
    return false;
  }

  const user = bootstrapData?.user;
  
  // Must be logged in
  if (!user) {
    return false;
  }

  // Check if user has admin.access permission
  const hasAdminAccess = (user.permissions || []).includes('admin.access');

  if (!hasAdminAccess) {
    return false;
  }

  // Check if user has NO roles (if roles array is empty or undefined, they're a tenant admin)
  // If user has roles, they're a regular user/member, not a tenant admin
  const hasRoles = user.roles && user.roles.length > 0;

  const isTenantAdmin = !hasRoles;

  return isTenantAdmin;
}
